export default class ColorMap {}